const getArticlePath = (article) => {
  let articlePath = `/${article.section}`;
  if ( article?.parent?.slug ) {
    /* FIX: CHANGE PATH, CREATE REDIRECTS */
    if ( article.parent.slug === "the-secretive-libyan-prisons-that-keep-migrants-out-of-europe" ) {
      articlePath += `/the-secretive-prisons-that-keep-migrants-out-of-europe`;
    }
    else {
      articlePath += `/${article.parent.slug}`;
    }
    //articlePath += `/${article.parent.slug}`;
  }
  if ( article?.subsection ) {
    articlePath += `/${article.subsection}`;
  }
  articlePath += `/${article.slug}/`;
  return articlePath;
};

export default getArticlePath;